import {
  FETCH_OTHERMEDIA_INFO,
  FETCH_OTHERMEDIA_INFO_SUCCESS
} from "./actionTypes"


export const fetchOtherMediaInfo = (param) => {
  return {
    type: FETCH_OTHERMEDIA_INFO,
    payload: {'theme_mode': param},
  }
}

export const fetchOtherMediaInfoSuccess = (response) => {
  return {
    type: FETCH_OTHERMEDIA_INFO_SUCCESS,
    payload: response,
  }
}